import React, {Component} from "react";
import Main from './components/MainComponent';
import './App.css';
import { Provider } from 'react-redux';
import store from './redux/store'


class App extends Component {

    render() {
        return (
            <Provider store={store}>
                <div>
                    <Main />
                </div>
            </Provider>
        );
    }

}

export default App;
